// extracted by mini-css-extract-plugin
export default {"wizard-step-hidden":"wizard-module__wizard-step-hidden__2YJal"};